import ko from 'knockout';

export default class ViewModel {
  constructor({
    i18n,
  }) {
    this.i18n = i18n;
    this.keywordQualityScore = ko.observable('');
  }

  updateAttribute({
    keywordQualityScore,
  }) {
    this.keywordQualityScore(this.i18n.getString('Keyword_Quality_Score', {
      keywordQualityScore: keywordQualityScore ?
        this.i18n.getString('Keyword_Quality_Score_Value', { keywordQualityScore }) :
        this.i18n.getString('Contextual_Response_Null'),
    }));
  }
}
